/**
 * Lab401: Extended list view for collection pages
 * PB-style table with running total bar, qty controls, and cart integration.
 */
(function () {
  'use strict';

  var outer = document.querySelector('[data-list-layout="list-view-extended"]');
  if (!outer) return;

  var barEl = document.getElementById('clx-bar');
  var summaryEl = document.getElementById('clx-bar-summary');
  var detailEl = document.getElementById('clx-bar-detail');
  if (!barEl || !summaryEl || !detailEl) return;

  var labels = JSON.parse(document.getElementById('clx-translations').textContent);
  var selections = {};
  var busy = false;

  /* ── Helpers ─────────────────────────────────────────────────── */

  function formatMoney(cents) {
    var fmt = window.LAB401_MONEY_FORMAT || '\u20ac{{amount}}';
    var amount = (cents / 100).toFixed(2);
    var amountNoDecimals = Math.round(cents / 100).toString();
    var amountWithComma = amount.replace('.', ',');
    return fmt
      .replace('{{amount_with_comma_separator}}', amountWithComma)
      .replace('{{amount_no_decimals}}', amountNoDecimals)
      .replace('{{amount_no_decimals_with_comma_separator}}', amountNoDecimals)
      .replace('{{amount}}', amount);
  }

  function esc(str) {
    var el = document.createElement('span');
    el.textContent = str;
    return el.innerHTML;
  }

  function guarded(fn) {
    return function (e) {
      if (busy) return;
      fn.call(this, e);
    };
  }

  /* ── Selection management ───────────────────────────────────── */

  function setQty(variantId, qty) {
    variantId = String(variantId);
    if (qty <= 0) {
      delete selections[variantId];
    } else {
      selections[variantId] = qty;
    }
    updateRow(variantId);
    renderBar();
  }

  function updateRow(variantId) {
    var row = document.querySelector('.clx-row[data-clx-variant="' + variantId + '"]');
    if (!row) return;

    var qty = selections[variantId] || 0;
    var addBtn = row.querySelector('[data-clx-add]');
    var qtyControls = row.querySelector('.clx-qty-controls');
    var qtyVal = row.querySelector('.clx-qty-val');

    if (addBtn) addBtn.style.display = qty > 0 ? 'none' : '';
    if (qtyControls) qtyControls.style.display = qty > 0 ? 'flex' : 'none';
    if (qtyVal) qtyVal.textContent = qty;

    if (qty > 0) {
      row.classList.add('clx-row--selected');
    } else {
      row.classList.remove('clx-row--selected');
    }
  }

  /* ── Running total bar ──────────────────────────────────────── */

  function renderBar() {
    var keys = Object.keys(selections);
    var totalItems = 0;
    var totalCents = 0;

    keys.forEach(function (vid) {
      var qty = selections[vid];
      var row = document.querySelector('.clx-row[data-clx-variant="' + vid + '"]');
      var price = row ? parseInt(row.getAttribute('data-clx-price'), 10) : 0;
      totalItems += qty;
      totalCents += price * qty;
    });

    if (totalItems === 0) {
      barEl.classList.remove('clx-bar--visible', 'clx-bar--expanded');
      return;
    }

    barEl.classList.add('clx-bar--visible');

    // Build summary
    var productLabel = totalItems === 1 ? labels.product_one : labels.product_other;
    var statsHtml = '<div class="clx-bar__stats-group">';
    statsHtml += '<div class="clx-bar__stat"><strong>' + totalItems + '</strong> ' + esc(productLabel) + '</div>';
    statsHtml += '<span class="clx-bar__details-pill" data-clx-toggle-detail>' + esc(labels.details);
    statsHtml += '<svg class="clx-bar__expand-icon" viewBox="0 0 20 20"><path d="M6 8l4 4 4-4" stroke="currentColor" stroke-width="2" fill="none"/></svg>';
    statsHtml += '</span>';
    statsHtml += '<div class="clx-bar__stat">' + esc(labels.total) + ': <strong>' + formatMoney(totalCents) + '</strong></div>';
    statsHtml += '</div>';

    statsHtml += '<div class="clx-bar__actions">';
    statsHtml += '<button class="clx-bar__confirm" data-clx-confirm>' + esc(labels.add_to_cart) + '</button>';
    statsHtml += '<button class="clx-bar__reset" data-clx-reset>' + esc(labels.reset) + '</button>';
    statsHtml += '</div>';

    summaryEl.textContent = '';
    summaryEl.insertAdjacentHTML('beforeend', statsHtml);

    // Build detail table
    var dHtml = '<table class="clx-bar__table"><thead><tr>';
    dHtml += '<th>' + esc(labels.product) + '</th><th>' + esc(labels.quantity) + '</th><th>' + esc(labels.unit) + '</th><th>' + esc(labels.subtotal) + '</th>';
    dHtml += '</tr></thead><tbody>';

    keys.forEach(function (vid) {
      var qty = selections[vid];
      var row = document.querySelector('.clx-row[data-clx-variant="' + vid + '"]');
      var price = row ? parseInt(row.getAttribute('data-clx-price'), 10) : 0;
      var title = row ? row.getAttribute('data-clx-title') : '';
      var displayTitle = title.length > 40 ? title.substring(0, 40) + '\u2026' : title;

      dHtml += '<tr>';
      dHtml += '<td>' + esc(displayTitle) + '</td>';
      dHtml += '<td>' + qty + '</td>';
      dHtml += '<td>' + formatMoney(price) + '</td>';
      dHtml += '<td>' + formatMoney(price * qty) + '</td>';
      dHtml += '</tr>';
    });

    dHtml += '</tbody><tfoot><tr>';
    dHtml += '<td colspan="3">' + esc(labels.total) + '</td>';
    dHtml += '<td>' + formatMoney(totalCents) + '</td>';
    dHtml += '</tr></tfoot></table>';

    detailEl.textContent = '';
    detailEl.insertAdjacentHTML('beforeend', dHtml);

    // Bind bar events
    bindBarEvents();
  }

  function bindBarEvents() {
    var toggleBtn = summaryEl.querySelector('[data-clx-toggle-detail]');
    if (toggleBtn) {
      toggleBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        barEl.classList.toggle('clx-bar--expanded');
      });
    }

    var confirmBtn = summaryEl.querySelector('[data-clx-confirm]');
    if (confirmBtn) {
      confirmBtn.addEventListener('click', guarded(function (e) {
        e.stopPropagation();
        addToCart();
      }));
    }

    var resetBtn = summaryEl.querySelector('[data-clx-reset]');
    if (resetBtn) {
      resetBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        resetSelection();
      });
    }
  }

  /* ── Cart integration ───────────────────────────────────────── */

  function addToCart() {
    var items = [];
    Object.keys(selections).forEach(function (vid) {
      items.push({ id: parseInt(vid, 10), quantity: selections[vid] });
    });

    if (items.length === 0) return;

    busy = true;
    var confirmBtn = summaryEl.querySelector('[data-clx-confirm]');
    if (confirmBtn) confirmBtn.textContent = labels.adding;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('Cart error');
        return r.json();
      })
      .then(function () {
        resetSelection();
        if (confirmBtn) confirmBtn.textContent = labels.add_to_cart;
        busy = false;
      })
      .catch(function () {
        if (confirmBtn) confirmBtn.textContent = labels.error;
        busy = false;
      });
  }

  function resetSelection() {
    var keys = Object.keys(selections);
    selections = {};
    keys.forEach(function (vid) {
      updateRow(vid);
    });
    renderBar();
    busy = false;
  }

  /* ── Event delegation for table ─────────────────────────────── */

  var tableWrapper = outer.querySelector('.clx-table-wrapper');
  if (!tableWrapper) return;

  tableWrapper.addEventListener('click', function (e) {
    var addBtn = e.target.closest('[data-clx-add]');
    if (addBtn) {
      e.preventDefault();
      setQty(addBtn.getAttribute('data-clx-add'), 1);
      return;
    }

    var incBtn = e.target.closest('[data-clx-inc]');
    if (incBtn) {
      e.preventDefault();
      var incId = incBtn.getAttribute('data-clx-inc');
      setQty(incId, (selections[incId] || 0) + 1);
      return;
    }

    var decBtn = e.target.closest('[data-clx-dec]');
    if (decBtn) {
      e.preventDefault();
      var decId = decBtn.getAttribute('data-clx-dec');
      setQty(decId, (selections[decId] || 0) - 1);
      return;
    }
  });
})();
